import { callProcedure } from 'core/classes/helpers/callProcedure'
import Logger from 'core/utils/Logger'

import { mapAssortmentCard } from '../../../widgets/assortmentTab/mappers/mapAssortmentCard'
import { IAssortmentItem } from '../models/data/IAssortmentItem'

interface IAssortmentItemWithoutEntryId extends Omit<IAssortmentItem, 'EntryId'> {
  EntryId?: number
}

export const applyAssortmentItemsChanges = async (cards: IAssortmentItem[]) => {
  const data = cards.map((card) => {
    const mapped = mapAssortmentCard(card) as IAssortmentItemWithoutEntryId
    if (mapped.EntryId && mapped.EntryId < 0) {
      delete mapped.EntryId
    }
    return mapped
  })

  try {
    const response = await callProcedure('spJBPAssortmentApplyChanges', {
      'p.Data': data,
    })

    return response
  } catch (e) {
    Logger.log(e)
    return []
  }
}
